export enum CustomerAdditionalInfoDisplay {
  DISPLAY = 'display',
  HIDDEN = 'hidden',
  COMPLETELY_HIDDEN = 'completely_hidden',
}

export type CustomerAdditionalInfoDisplayType = CustomerAdditionalInfoDisplay